import PillarContentHeader from './PillarContentHeader'

export default PillarContentHeader
